
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eMqDh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5ee25ac220dd5fa4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $5ee25ac220dd5fa4$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': 'Aggiungi una reazione',
    'fabric.reactions.error.unexpected': 'Le reazioni non sono temporaneamente disponibili',
    'fabric.reactions.loading': 'Caricamento in corso...',
    'fabric.reactions.more.emojis': 'Altre emoji',
    'fabric.reactions.other.reacted.users': '{count, plural, one {e un altro} other {e altri {count}}}',
    'fabric.reactions.reactwithemoji': "Reagisci con l'emoji {emoji}",
    'fabric.reactions.summary': 'Visualizza tutte le reazioni degli utenti',
    'reaction-picker-trigger.add.reaction.message': 'Aggiungi una reazione',
    'reactions.dialog.close': 'Chiudi',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Navigazione a sinistra',
    'reactions.dialog.reactions.count': '{count, plural, one {{count,number} reazione in totale} other {{count,number} reazioni in totale}}',
    'reactions.dialog.right.navigate': 'Navigazione a destra',
    'reactions.dialog.viewall': 'Visualizza tutto',
    'reactions.dialog.viewall.tooltip': 'Visualizza tutte le reazioni degli utenti'
};

});


//# sourceMappingURL=it.a152e1ea.js.map
